import { cn } from "../utils/helpers";
import { SvgProps } from "../utils/types";

export default function ChevronRightIcon({ className }: SvgProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={cn("shrink-0 size-3.5", className)}
        >
            <polyline points="9 18 15 12 9 6" />
        </svg>
    );
}
